import { render } from "./GamerDetails.vue?vue&type=template&id=e6b36584&scoped=true"
import script from "./GamerDetails.vue?vue&type=script&lang=js"
export * from "./GamerDetails.vue?vue&type=script&lang=js"

import "./GamerDetails.vue?vue&type=style&index=0&id=e6b36584&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e6b36584"

export default script